import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-pressroom',
    templateUrl: './pressroom.component.html',
    styleUrls: ['./pressroom.component.scss'],
    standalone: false
})
export class PressroomComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
